<h1 mat-dialog-title>Oude passagiers verwijderen</h1>

<div mat-dialog-content class="dialog-content">
  @if (loading() && !organisations().length) {
    <mat-spinner diameter="32"></mat-spinner>
  }

  <form class="dialog-form" autocomplete="off">
    <mat-form-field>
      <mat-label>Organisatie</mat-label>
      <mat-select [formControl]="organisationControl">
        @for (organisation of organisations(); track organisation.id) {
          <mat-option [value]="organisation">{{ organisation.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Zoeken</mat-label>
      <input matInput [formControl]="searchControl" />
      <button
        type="button"
        mat-icon-button
        matSuffix
        [disabled]="searchControl.disabled"
        aria-label="Zoekopdracht wissen"
        (click)="searchControl.setValue(''); $event.stopPropagation()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <div class="user-table-wrapper">
    <table class="user-table">
      <thead>
        <tr>
          <th class="selection-column" scope="col">
            <mat-checkbox
              [checked]="allVisibleUsersSelected()"
              [indeterminate]="selectedIds().length > 0 && !allVisibleUsersSelected()"
              [disabled]="!organisationControl.value || loading() || processing() || !visibleUsers().length"
              [aria-label]="'Alle zichtbare passagiers selecteren (' + visibleUsers().length + ')'"
              (change)="toggleVisibleSelection($event.checked)"
            ></mat-checkbox>
          </th>
          <th scope="col">Naam</th>
          <th scope="col">E-mail</th>
          <th scope="col">Telefoon</th>
          <th scope="col">Verborgen sinds</th>
        </tr>
      </thead>
      <tbody>
        @if (loading() && organisationControl.value) {
          <tr>
            <td colspan="5" class="table-status"><mat-spinner diameter="32"></mat-spinner></td>
          </tr>
        } @else if (!organisationControl.value) {
          <tr>
            <td colspan="5" class="table-status">Selecteer een organisatie om passagiers te laden.</td>
          </tr>
        } @else {
          @for (user of visibleUsers(); track user.id) {
            <tr>
              <td class="selection-column">
                <mat-checkbox
                  [checked]="selectedIds().includes(user.id)"
                  [disabled]="processing()"
                  [aria-label]="(user.name || 'Onbekende passagier') + ' selecteren'"
                  (change)="toggleSelection(user, $event.checked)"
                ></mat-checkbox>
              </td>
              <td class="user-name">{{ user.name || 'Onbekend' }}</td>
              <td>{{ user.email || '-' }}</td>
              <td>{{ user.phone || user.phoneNumber || '-' }}</td>
              <td>{{ formatDate(user.hiddenDate) }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5" class="table-status">Geen geschikte verborgen passagiers gevonden.</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  @if (errorMessage()) {
    <p class="error">{{ errorMessage() }}</p>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Sluiten</button>
  <button mat-flat-button type="button" [disabled]="!selectedIds().length || processing()" (click)="requestDeletion()">
    @if (processing()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Verwijderen ({{ selectedIds().length }})
    }
  </button>
</div>
